export default {
  copyright: '© {{year}} Industrial Alliance Insurance and Financial Services Inc. – iA Financial Group. All rights reserved.',
};
